__turbopack_context__.v({
  "richtext": "rich-text-module__Wt9N7W__richtext",
});
